import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { COUNTDOWN_SECONDS } from '../data/offer';
type CountdownValue = {
  hours: string;
  minutes: string;
  seconds: string;
  formatted: string;
  isExpired: boolean;
};
const CountdownContext = createContext<CountdownValue | null>(null);
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function CountdownProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [remaining, setRemaining] = useState<number>(COUNTDOWN_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 0 ? 0 : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const value = useMemo<CountdownValue>(() => {
    const hours = Math.floor(remaining / 3600);
    const minutes = Math.floor(remaining % 3600 / 60);
    const seconds = remaining % 60;
    return {
      hours: pad(hours),
      minutes: pad(minutes),
      seconds: pad(seconds),
      formatted: `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`,
      isExpired: remaining <= 0
    };
  }, [remaining]);
  return <CountdownContext.Provider value={value} data-id="element-506" data-mp="3k52u2bppxozy">{children}</CountdownContext.Provider>;
}
export function useCountdown(): CountdownValue {
  const ctx = useContext(CountdownContext);
  if (!ctx) {
    throw new Error('useCountdown must be used inside a CountdownProvider');
  }
  return ctx;
}